import { Table } from "@/features/Table";
import { useTranslation } from "react-i18next";
import { C5EventRow, useC5EventColumns } from "./columns";
import { FilterC5Events, type FilterC5EventsSchema } from "./filter";

const client = "c5";
const table_name = "c5_events";

export function C5EventsTable() {
  const { t } = useTranslation();
  const columns = useC5EventColumns();

  return (
    <Table<C5EventRow, FilterC5EventsSchema>
      label={t(`${table_name}.title`, { ns: "tables", defaultValue: "Events" })}
      client={client}
      table_name={table_name}
      columns={columns}
      columnVisibilityInit={{ created_at: false, updated_at: false }}
      filter={<FilterC5Events />}
      actions={[
        {
          label: "actions.new",
          route: `${client}/${table_name}/new`,
        },
      ]}
    />
  );
}
